export default __webpack_public_path__ + "files/0d6cd8de0d26cc49e078421a323d5ed8.mp3";